<button mat-mini-fab class="mat-mini-fab-map-control" (click)="zoomIn()" [matTooltip]="'map.control_zoom_in.tooltip' | translate"
  matTooltipPosition="left" matTooltipShowDelay="1000">
  <mat-icon>add</mat-icon>
</button>
